import React from "react";
import { apiGetPengaturan } from "@/lib/api";

// Settings change rarely: one request per page load, shared by every
// component. PengaturanPage calls resetPengaturan() after saving.
let cache = null;

export function resetPengaturan() {
  cache = null;
}

export function usePengaturan() {
  const [cfg, setCfg] = React.useState(null);
  React.useEffect(() => {
    let alive = true;
    if (!cache) cache = apiGetPengaturan().catch((e) => { cache = null; throw e; });
    cache.then((d) => alive && setCfg(d)).catch(() => {});
    return () => { alive = false; };
  }, []);
  return cfg;
}

// F1.5-A: the shop has no thermal printer; print links are hidden unless the
// owner switches them on (also hidden while the settings are loading).
export function useCetak() {
  const cfg = usePengaturan();
  return { nota: !!cfg?.tampilkan_cetak_thermal, spk: !!cfg?.tampilkan_cetak_spk };
}
